<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="店铺名称" prop="shop_id">
                <el-select
                        v-model="queryForm.shop_id"
                        filterable
                        remote
                        clearable
                        :remote-method="remoteShopMethod"
                        placeholder="请输入店铺">
                    <el-option
                            v-for="item in shopList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="用户评分" prop="qualityCode">
                <el-select v-model="queryForm.qualityCode" placeholder="请输入">
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="4" value="4"></el-option>
                    <el-option label="5" value="5"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期" prop="date">
                <el-date-picker
                        v-model="queryForm.dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        placeholder="请选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="配送评价:" prop="deliveryScore">
                <el-select v-model="queryForm.deliveryScore" placeholder="请选择">
                    <el-option label="满意" value="100"></el-option>
                    <el-option label="不满意" value="85"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="评价关键字" prop="comment">
                <el-input v-model="queryForm.comment" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryForm.pageNo=1;fetchData()">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20">
            <!--<div>-->
                <!--<el-button type="primary" @click="exportExcel()">导出</el-button>-->
                <!--<form name="downForm" method="get"></form>-->
            <!--</div>-->
            <export-excel :params="exportParams" :action="$apiUrl.estimateList" :target="'oc'" :field="field" :filename="fileName" :fieldname="fieldName"></export-excel>
        </el-row>

        <!--table-->
        <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="cityName"
                    label="城市名称"
                    :show-overflow-tooltip="true"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="schoolName"
                    label="学校名称"
                    :show-overflow-tooltip="true"
                    width="140">
            </el-table-column>
            <el-table-column
                    prop="supplierCode"
                    label="店铺代码"
                    :show-overflow-tooltip="true"
                    width="130">
            </el-table-column>
            <el-table-column
                    prop="supplierShortName"
                    label="店铺名称"
                    :show-overflow-tooltip="true"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="qualityCode"
                    label="用户评分"
                    width="110">
            </el-table-column>
            <el-table-column
                    prop="deliveryScore"
                    label="配送评价"
                    :show-overflow-tooltip="true"
                    width="90">
                   <template slot-scope="scope">
                       <span v-if="scope.row.deliveryScore && scope.row.deliveryScore != 0">{{scope.row.deliveryScore == 85 ?'不满意':'满意'}}</span>
                       <span v-else>-</span>
                    </template> 
            </el-table-column>
            <el-table-column
                    prop="comment"
                    label="评价内容"
                    :show-overflow-tooltip="true"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="date"
                    label="评价时间"
                    width="">
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    fixed="right"
                    width="160">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="operateEstimate(scope.row)">{{scope.row.hided==1?'隐藏':'未隐藏'}}</el-button>
                    <el-button size="mini" type="text" @click="viewDetail(scope.row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--pagination-->
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNo"
                :page-sizes="pageSizes"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
        </el-pagination>

        <!--评价详情-->
        <el-dialog title="评价详情" :visible.sync="dialogVisible">
            <p>订单号：<span class="c6">{{detail.orderId}}</span></p>
            <p>评价时间：<span class="c6">{{detail.date}}</span></p>
            <p>用户昵称：<span class="c6">{{detail.userName || '匿名'}}</span></p>
            <p>用户评分：<span class="c6">{{detail.qualityCode}}分</span></p>
            <p>口味：<span class="c6">{{detail.tasteScore}}</span>星  包装：<span class="c6">{{detail.packScore}}</span>星   <span class="c6" v-if="detail.deliveryScore">配送：{{detail.deliveryScore}}</span></p>
            <p><span style="border: 1px solid #ddd;border-radius: 12px;font-size:12px;padding: 5px;margin-right: 5px" v-for="(item,index) in detail.deliveryEstimateList" v-bind:key="index">{{item}}</span></p>
            <p v-if="detail.deliveryComment">配送评价内容：<span class="c6">{{detail.deliveryComment}}</span></p>
            <p v-if="detail.comment">商家/菜品评价内容：<span class="c6">{{detail.comment}}</span></p>
            <p>
                商品评价：
                <span class="c6" v-for="(item,index) in detail.goodsMarkList" v-bind:key="index">{{item.goodsName}},{{item.goodsScore}}分</span>;
            </p>
            <p>
                评价图片：
                <img v-for="item in detail.urls" :src="item" width="60" height="60" alt="" style="margin-right: 10px;vertical-align: top;cursor: pointer" @click="preview(item)">
            </p>
        </el-dialog>
        <el-dialog
                title="预览"
                :visible.sync="innerVisible">
            <img :src="previewUrl" width="100%" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import moment from 'moment'
    import ExportExcel from "../../../components/exportExcel2.vue";
    export default {
        components: {ExportExcel},
        data() {
            return {
                queryFormLabelWidth: '100px',//自定义查询表单label宽度
                queryForm: {//查询表单数据
                    pageSize: 10,
                    pageNo: 1,
                    startTime: '',
                    endTime: '',
                    dateRange: [],
                    qualityCode: '',
                    shop_id: '',
                    comment: '',
                    deliveryScore: ''
                },
                shops: JSON.parse(localStorage.getItem('shops')),
                shopList: [],

                tableData: [],//表格数据
                total: 0,//总数
                pageSizes: [10,20,30,40,50],//自定义分页条数
                multipleSelection: [],//table选中项
                loading: true,//表格是否显示加载效果

                dialogVisible: false,
                detail: {},
                previewUrl: '',
                innerVisible: false,

                //导出
                exportParams: {},
                fileName: '评价统计表',
                fieldName: ['城市名称','学校名称','店铺代码','店铺名称','用户评分','配送评价','配送不满意原因','评价内容','评价时间'],
                field: ['cityName','schoolName','supplierCode','supplierShortName','qualityCode','deliveryScore','deliveryEstimateStr','comment','date']
            }
        },
        created(){
            var day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.dateRange = [day,new Date()];
            this.fetchData();

//            this.$api.post(this.$apiUrl.getSubListByToken,{is_need_commercial: 1,is_need_shop: 1},(res)=>{
//                if(res.data.shop_ids){
//                    for(let k in res.data.shop_ids){
//                        this.shops.push({id:k,name:res.data.shop_ids[k]});
//                    }
//                }else{
//                    this.shops = [];
//                }
//                this.fetchData();
//            })
        },
        methods: {
            //抓取列表数据
            fetchData() {
                let params = {...this.queryForm};
                params.startTime = moment(params.dateRange[0]).format('YYYYMMDD');
                params.endTime = moment(params.dateRange[1]).format('YYYYMMDD');
                delete params.dateRange;

                this.exportParams = {...params};
                this.exportParams.pageNo = 1;
                this.exportParams.pageSize = 99999;

                this.$apiJava.post(this.$apiUrl.estimateList,params,(res)=>{
                    this.loading = false;
                    this.total = res.data.total || 0;
                    this.tableData = res.data.list || [];
                },(res)=>{
                    this.$message.warning(res.message);
                    this.loading = false;
                    this.tableData = [];
                },'oc')
            },
            //查看详情
            viewDetail(item) {
                this.dialogVisible = true;
                this.$apiJava.get(this.$apiUrl.estimateDetail,{id: item.id},(res)=>{
                    this.detail = res.data;
                },null,'oc')
            },
            preview(item) {
                this.innerVisible = true;
                this.previewUrl = item;
            },
            //隐藏/恢复
            operateEstimate(item) {
                this.$apiJava.get(this.$apiUrl.estimateOperate,{id: item.id},(res)=>{
                    this.$message.success('修改成功');
                    this.fetchData();
                },null,'oc')
            },
            remoteShopMethod(query){
                if (query !== '') {
                    this.shopList = [];
                    var arr = [];
                    let len = this.shops.length;
                    var reg = new RegExp(query);
                    for(var i=0;i<len;i++){
                        //如果字符串中不包含目标字符会返回-1
                        if(this.shops[i].name.match(reg)){
                            this.shopList.push(this.shops[i]);
                        }
                    }
                } else {
                    this.shopList = [];
                }
            },
            //表单重置 item上需要添加prop属性
            resetForm(formName) {
                this.$refs[formName].resetFields();
//                this.queryForm.dateRange = [];
            },
            //切换每页显示条数操作
            handleSizeChange(val) {
                this.queryForm.pageSize = val;
                this.fetchData();
            },
            //切换页码操作
            handleCurrentChange(val) {
                this.queryForm.pageNo = val;
                this.fetchData();
            }
        }
    }
</script>

<style lang="scss"  scoped>
    .el-dialog__body p{
        line-height: 35px;
    }
</style>


// WEBPACK FOOTER //
// list.vue?206c3364